export default Object.freeze({
    BAJO: 'BAJO',
    MEDIO: 'MEDIO',
    ALTO: 'ALTO'
})
